import React from 'react';
import { Icon } from './Icon.js';
export const IconPlugFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M14.25,4h-1.75V1.75c0-.414-.336-.75-.75-.75s-.75,.336-.75,.75v2.25H7V1.75c0-.414-.336-.75-.75-.75s-.75,.336-.75,.75v2.25h-1.75c-.965,0-1.75,.785-1.75,1.75v1.75c0,3.606,2.742,6.583,6.25,6.958v1.792c0,.414,.336,.75,.75,.75s.75-.336,.75-.75v-1.792c3.508-.376,6.25-3.352,6.25-6.958v-1.75c0-.965-.785-1.75-1.75-1.75Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconPlugFill18.js.map